var _style, _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 378.78 263.42",
    style: {
      enableBackground: "new 0 0 378.78 263.42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#A4549C;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#A3539B;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#A2529B;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#A2519A;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#A2509A;}\n\t.st5{clip-path:url(#SVGID_2_);fill:#A14F99;}\n\t.st6{clip-path:url(#SVGID_2_);fill:#A04E98;}\n\t.st7{clip-path:url(#SVGID_2_);fill:#A04D98;}\n\t.st8{clip-path:url(#SVGID_2_);fill:#9F4C97;}\n\t.st9{clip-path:url(#SVGID_2_);fill:#9F4B97;}\n\t.st10{clip-path:url(#SVGID_2_);fill:#9E4B96;}\n\t.st11{clip-path:url(#SVGID_2_);fill:#9E4A96;}\n\t.st12{clip-path:url(#SVGID_2_);fill:#9D4995;}\n\t.st13{clip-path:url(#SVGID_2_);fill:#9C4995;}\n\t.st14{clip-path:url(#SVGID_2_);fill:#9C4895;}\n\t.st15{clip-path:url(#SVGID_2_);fill:#9B4895;}\n\t.st16{clip-path:url(#SVGID_2_);fill:#9B4794;}\n\t.st17{clip-path:url(#SVGID_2_);fill:#9B4694;}\n\t.st18{clip-path:url(#SVGID_2_);fill:#9B4593;}\n\t.st19{clip-path:url(#SVGID_2_);fill:#9A4493;}\n\t.st20{clip-path:url(#SVGID_2_);fill:#9A4393;}\n\t.st21{clip-path:url(#SVGID_2_);fill:#994393;}\n\t.st22{clip-path:url(#SVGID_2_);fill:#984392;}\n\t.st23{clip-path:url(#SVGID_2_);fill:#984292;}\n\t.st24{clip-path:url(#SVGID_2_);fill:#984191;}\n\t.st25{clip-path:url(#SVGID_2_);fill:#974091;}\n\t.st26{clip-path:url(#SVGID_2_);fill:#973F90;}\n\t.st27{clip-path:url(#SVGID_2_);fill:#963E90;}\n\t.st28{clip-path:url(#SVGID_2_);fill:#953D8F;}\n\t.st29{clip-path:url(#SVGID_2_);fill:#943C8F;}\n\t.st30{clip-path:url(#SVGID_2_);fill:#943C8E;}\n\t.st31{clip-path:url(#SVGID_2_);fill:#933B8E;}\n\t.st32{clip-path:url(#SVGID_2_);fill:#933A8E;}\n\t.st33{clip-path:url(#SVGID_2_);fill:#93398D;}\n\t.st34{clip-path:url(#SVGID_2_);fill:#92388C;}\n\t.st35{clip-path:url(#SVGID_2_);fill:#91378C;}\n\t.st36{clip-path:url(#SVGID_2_);fill:#91368C;}\n\t.st37{clip-path:url(#SVGID_2_);fill:#91358B;}\n\t.st38{clip-path:url(#SVGID_2_);fill:#91348B;}\n\t.st39{clip-path:url(#SVGID_2_);fill:#90338A;}\n\t.st40{clip-path:url(#SVGID_2_);fill:#8F328A;}\n\t.st41{clip-path:url(#SVGID_2_);fill:#8E3189;}\n\t.st42{clip-path:url(#SVGID_2_);fill:#8E3089;}\n\t.st43{clip-path:url(#SVGID_2_);fill:#8D2F89;}\n\t.st44{clip-path:url(#SVGID_2_);fill:#8C2E88;}\n\t.st45{clip-path:url(#SVGID_2_);fill:#8B2D87;}\n\t.st46{clip-path:url(#SVGID_2_);fill:#8B2C87;}\n\t.st47{clip-path:url(#SVGID_2_);fill:#8A2A86;}\n\t.st48{clip-path:url(#SVGID_2_);fill:#892A86;}\n\t.st49{clip-path:url(#SVGID_2_);fill:#882885;}\n\t.st50{clip-path:url(#SVGID_2_);fill:#872684;}\n\t.st51{clip-path:url(#SVGID_2_);fill:#862584;}\n\t.st52{clip-path:url(#SVGID_2_);fill:#842382;}\n\t.st53{clip-path:url(#SVGID_2_);fill:#842482;}\n\t.st54{clip-path:url(#SVGID_2_);fill:#832281;}\n\t.st55{clip-path:url(#SVGID_2_);fill:#82207F;}\n\t.st56{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M377.91,166.06l-141.97,97.36l-165.24,0l154.63-100.24L0,0l144.01,0L377.91,166.06L377.91,166.06z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-2.69-1.93v329.39V-1.93z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.69,
    y: -1.93,
    className: "st0",
    width: 6.45,
    height: 329.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.77,
    y: -1.93,
    className: "st1",
    width: 6.45,
    height: 329.39
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.22,
    y: -1.93,
    className: "st2",
    width: 6.45,
    height: 329.39
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.67,
    y: -1.93,
    className: "st3",
    width: 6.45,
    height: 329.39
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: -1.93,
    className: "st3",
    width: 6.45,
    height: 329.39
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29.57,
    y: -1.93,
    className: "st4",
    width: 6.45,
    height: 329.39
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36.02,
    y: -1.93,
    className: "st5",
    width: 6.45,
    height: 329.39
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42.47,
    y: -1.93,
    className: "st5",
    width: 6.45,
    height: 329.39
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 48.92,
    y: -1.93,
    className: "st6",
    width: 6.45,
    height: 329.39
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 55.37,
    y: -1.93,
    className: "st7",
    width: 6.45,
    height: 329.39
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 61.82,
    y: -1.93,
    className: "st8",
    width: 6.45,
    height: 329.39
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 68.27,
    y: -1.93,
    className: "st9",
    width: 6.45,
    height: 329.39
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 74.72,
    y: -1.93,
    className: "st10",
    width: 6.45,
    height: 329.39
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 81.17,
    y: -1.93,
    className: "st11",
    width: 6.45,
    height: 329.39
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 87.63,
    y: -1.93,
    className: "st12",
    width: 6.45,
    height: 329.39
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 94.08,
    y: -1.93,
    className: "st13",
    width: 6.45,
    height: 329.39
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 100.53,
    y: -1.93,
    className: "st14",
    width: 6.45,
    height: 329.39
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 106.98,
    y: -1.93,
    className: "st15",
    width: 6.45,
    height: 329.39
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 113.43,
    y: -1.93,
    className: "st16",
    width: 6.45,
    height: 329.39
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 119.88,
    y: -1.93,
    className: "st17",
    width: 6.45,
    height: 329.39
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 126.33,
    y: -1.93,
    className: "st18",
    width: 6.45,
    height: 329.39
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 132.78,
    y: -1.93,
    className: "st19",
    width: 6.45,
    height: 329.39
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 139.23,
    y: -1.93,
    className: "st20",
    width: 6.45,
    height: 329.39
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 145.68,
    y: -1.93,
    className: "st21",
    width: 6.45,
    height: 329.39
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 152.13,
    y: -1.93,
    className: "st22",
    width: 6.45,
    height: 329.39
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 158.58,
    y: -1.93,
    className: "st23",
    width: 6.45,
    height: 329.39
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 165.03,
    y: -1.93,
    className: "st24",
    width: 6.45,
    height: 329.39
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 171.49,
    y: -1.93,
    className: "st25",
    width: 6.45,
    height: 329.39
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 177.94,
    y: -1.93,
    className: "st26",
    width: 6.45,
    height: 329.39
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 184.39,
    y: -1.93,
    className: "st27",
    width: 6.45,
    height: 329.39
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: -1.93,
    className: "st28",
    width: 6.45,
    height: 329.39
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 197.29,
    y: -1.93,
    className: "st29",
    width: 6.45,
    height: 329.39
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 203.74,
    y: -1.93,
    className: "st30",
    width: 6.45,
    height: 329.39
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 210.19,
    y: -1.93,
    className: "st31",
    width: 6.45,
    height: 329.39
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 216.64,
    y: -1.93,
    className: "st32",
    width: 6.45,
    height: 329.39
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 223.09,
    y: -1.93,
    className: "st33",
    width: 6.45,
    height: 329.39
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 229.54,
    y: -1.93,
    className: "st34",
    width: 6.45,
    height: 329.39
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 235.99,
    y: -1.93,
    className: "st35",
    width: 6.45,
    height: 329.39
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 242.44,
    y: -1.93,
    className: "st36",
    width: 6.45,
    height: 329.39
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 248.89,
    y: -1.93,
    className: "st37",
    width: 6.45,
    height: 329.39
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 255.35,
    y: -1.93,
    className: "st38",
    width: 6.45,
    height: 329.39
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 261.8,
    y: -1.93,
    className: "st39",
    width: 6.45,
    height: 329.39
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 268.25,
    y: -1.93,
    className: "st40",
    width: 6.45,
    height: 329.39
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 274.7,
    y: -1.93,
    className: "st41",
    width: 6.45,
    height: 329.39
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 281.15,
    y: -1.93,
    className: "st42",
    width: 6.45,
    height: 329.39
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 287.6,
    y: -1.93,
    className: "st43",
    width: 6.45,
    height: 329.39
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 294.05,
    y: -1.93,
    className: "st44",
    width: 6.45,
    height: 329.39
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 300.5,
    y: -1.93,
    className: "st45",
    width: 6.45,
    height: 329.39
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 306.95,
    y: -1.93,
    className: "st46",
    width: 6.45,
    height: 329.39
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 313.4,
    y: -1.93,
    className: "st47",
    width: 6.45,
    height: 329.39
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 319.85,
    y: -1.93,
    className: "st48",
    width: 6.45,
    height: 329.39
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 326.3,
    y: -1.93,
    className: "st49",
    width: 6.45,
    height: 329.39
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 332.75,
    y: -1.93,
    className: "st49",
    width: 6.45,
    height: 329.39
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 339.21,
    y: -1.93,
    className: "st50",
    width: 6.45,
    height: 329.39
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 345.66,
    y: -1.93,
    className: "st51",
    width: 6.45,
    height: 329.39
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 352.11,
    y: -1.93,
    className: "st52",
    width: 6.45,
    height: 329.39
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 358.56,
    y: -1.93,
    className: "st53",
    width: 6.45,
    height: 329.39
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 365.01,
    y: -1.93,
    className: "st54",
    width: 6.45,
    height: 329.39
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 371.46,
    y: -1.93,
    className: "st55",
    width: 6.45,
    height: 329.39
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M377.91,327.46V-1.93V327.46z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.6372,
    y1: 131.7112,
    x2: 378.7772,
    y2: 131.7112
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M235.94,263.42l141.1-97.37L143.86,0.5L105.91,0h38.98l233.89,166.06l-0.58,0.41l-140.49,96.95H235.94H71.64 H235.94z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigarrow);
export default __webpack_public_path__ + "static/media/bigarrow.2599ddab8a9553561ee039de10a4670d.svg";
export { ForwardRef as ReactComponent };